import { UseFormReturnType } from "@mantine/form";

import { EncounterNotesType } from "@/encounters/constants/encounter-notes-type";
import { EncounterAnswersFormType } from "@/encounters/zod-schemas/encounter-answers";

import EncounterFormNote from "./EncounterFormNote";

interface EncounterClientSummaryAndInstructionsProps {
  isEncounterActive: boolean;
  isAmendment?: boolean;
  form: UseFormReturnType<EncounterAnswersFormType>;
}

export default function EncounterClientSummaryAndInstructions({
  isEncounterActive,
  isAmendment,
  form,
}: EncounterClientSummaryAndInstructionsProps) {
  return (
    <>
      <EncounterFormNote
        form={form}
        isAmendment={isAmendment}
        title="Client Summary & Instructions"
        isEncounterActive={isEncounterActive}
        type={EncounterNotesType.CLIENT_SUMMARY_NOTE}
        subtitle="The client will be notified of any changes made"
      />
    </>
  );
}
